<p class="text-white">
	Are you sure you want to leave this page? All information entered will be lost
	if you proceed to navigate away from this screen.
</p>
<p class="text-white">Do you wish to proceed?</p>
<div class="flex justify-center mt-10">
	<button class="mr-2" (click)="closePortal()">Leave this page</button>

	<button class="ml-2" (click)="stay()">Stay on this page</button>
</div>
